/* 8px tolerance accounts for sub-pixel rounding and smooth-scroll overshoot */
const DELTA_PX = 8;

export interface TableOverflowState {
	left: boolean;
	right: boolean;
}

export function readTableOverflowState(node: HTMLElement): undefined | TableOverflowState {
	if (node.scrollWidth <= node.clientWidth) {
		return undefined;
	}

	if (node.scrollLeft <= DELTA_PX) {
		return { left: false, right: true };
	}

	if (node.scrollLeft + node.clientWidth >= node.scrollWidth - DELTA_PX) {
		return { left: true, right: false };
	}

	return { left: true, right: true };
}
